// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const overview = "Overview__overview__Khbjt";
export const section = "Overview__section__e1zmS";
export const title = "Overview__title__RVOu6";
export const body = "Overview__body__KtNWk font-faces__sansRegular__c8KXl font-faces__sans__uCf65";